document.addEventListener('DOMContentLoaded', function () {

  var hasGSAP = typeof gsap !== 'undefined';
  var isMobileViewport = window.matchMedia('(max-width: 900px)').matches;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enableVisualEffects = hasGSAP && !isMobileViewport && !prefersReducedMotion;

  if (enableVisualEffects && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
  }

  var EASE_SPRING = "cubic-bezier(0.34, 1.56, 0.64, 1)";  /* springy overshoot */
  var EASE_SOFT = "power3.out";

  /* ---------- Preloader ---------- */
  var preloader = document.getElementById('preloader');
  if (preloader) {
    var hidePreloader = function () {
      if (preloader.classList.contains('is-hidden')) return;
      if (enableVisualEffects) {
        gsap.to(preloader, { opacity: 0, duration: .7, ease: EASE_SOFT, onComplete: function(){ preloader.classList.add('is-hidden'); } });
      } else {
        preloader.classList.add('is-hidden');
      }
    };
    window.addEventListener('load', function () { setTimeout(hidePreloader, 300); });
    /* Safety net: never let the preloader stay stuck if 'load' is delayed by a slow embed/script */
    setTimeout(hidePreloader, 2500);
  }

  /* ---------- Smooth cursor glow (lerped) ---------- */
  var glow = document.getElementById('cursorGlow');
  if (glow && window.matchMedia('(hover: hover)').matches) {
    if (enableVisualEffects) {
      var glowX = gsap.quickTo(glow, "x", { duration: 0.6, ease: "power3" });
      var glowY = gsap.quickTo(glow, "y", { duration: 0.6, ease: "power3" });
      document.addEventListener('mousemove', function (e) {
        glowX(e.clientX);
        glowY(e.clientY);
      });
      gsap.set(glow, { xPercent: -50, yPercent: -50 });
    } else {
      document.addEventListener('mousemove', function (e) {
        glow.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px) translate(-50%,-50%)';
      });
    }
  }

  /* ---------- Hero entrance (staggered spring) ---------- */
  if (enableVisualEffects) {
    gsap.utils.toArray('.reveal').forEach(function (el, i) {
      gsap.fromTo(el, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1, ease: "back.out(1.4)", delay: i * 0.12 });
    });
  }

  /* ---------- Scroll reveal via ScrollTrigger (fallback: IntersectionObserver) ---------- */
  var revealSelectors = '.reveal-on-scroll, .reveal-scale, .reveal-left, .reveal-right';
  if (enableVisualEffects && typeof ScrollTrigger !== 'undefined') {
    gsap.utils.toArray(revealSelectors.split(',')).forEach(function(sel){});
    document.querySelectorAll(revealSelectors).forEach(function (el, i) {
      var fromVars = { opacity: 0, y: 60 };
      if (el.classList.contains('reveal-scale')) fromVars = { opacity: 0, scale: 0.8 };
      if (el.classList.contains('reveal-left')) fromVars = { opacity: 0, x: -70 };
      if (el.classList.contains('reveal-right')) fromVars = { opacity: 0, x: 70 };
      gsap.fromTo(el, fromVars, {
        opacity: 1, y: 0, x: 0, scale: 1,
        duration: 1.1, ease: "power4.out",
        scrollTrigger: { trigger: el, start: "top 88%" }
      });
    });
    /* stagger children inside product grids */
    document.querySelectorAll('.product-grid').forEach(function (grid) {
      gsap.fromTo(grid.children, { opacity: 0, y: 50 }, {
        opacity: 1, y: 0, duration: .9, ease: "back.out(1.3)", stagger: 0.12,
        scrollTrigger: { trigger: grid, start: "top 85%" }
      });
    });
  } else {
    var revealEls = document.querySelectorAll(revealSelectors);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  /* ---------- Mobile nav drawer ---------- */
  var mobileToggle = document.getElementById('mobileNavToggle');
  var siteNav = document.querySelector('.site-nav');
  var mobileBackdrop = document.getElementById('mobileNavBackdrop');
  function openMobileNav() {
    if (siteNav) siteNav.classList.add('mobile-open');
    if (mobileBackdrop) mobileBackdrop.classList.add('is-open');
    if (mobileToggle) mobileToggle.classList.add('is-open');
  }
  function closeMobileNav() {
    if (siteNav) siteNav.classList.remove('mobile-open');
    if (mobileBackdrop) mobileBackdrop.classList.remove('is-open');
    if (mobileToggle) mobileToggle.classList.remove('is-open');
  }
  if (mobileToggle && siteNav) {
    mobileToggle.addEventListener('click', function () {
      if (siteNav.classList.contains('mobile-open')) closeMobileNav(); else openMobileNav();
    });
  }
  if (mobileBackdrop) mobileBackdrop.addEventListener('click', closeMobileNav);
  document.querySelectorAll('.site-nav a').forEach(function (a) { a.addEventListener('click', closeMobileNav); });

  /* ---------- Sticky mobile add-to-cart bar ---------- */
  var stickyAtc = document.getElementById('stickyAtc');
  var mainAddToCart = document.getElementById('mainAddToCart');
  if (stickyAtc && mainAddToCart) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    atcObserver.observe(mainAddToCart);

    var stickyBtn = document.getElementById('stickyAddToCart');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { mainAddToCart.click(); });
    }
  }

  /* ---------- Image lightbox ---------- */
  var lightboxOverlay = document.getElementById('lightboxOverlay');
  var lightboxImage = document.getElementById('lightboxImage');
  var lightboxClose = document.getElementById('lightboxClose');
  var mainImageEl = document.getElementById('mainProductImage');
  if (lightboxOverlay && lightboxImage && mainImageEl) {
    mainImageEl.parentElement.addEventListener('click', function () {
      lightboxImage.src = mainImageEl.src;
      lightboxOverlay.classList.add('is-open');
    });
    lightboxClose.addEventListener('click', function () { lightboxOverlay.classList.remove('is-open'); });
    lightboxOverlay.addEventListener('click', function (e) { if (e.target === lightboxOverlay) lightboxOverlay.classList.remove('is-open'); });
  }

  /* ---------- Recently Viewed ---------- */
  (function () {
    var section = document.getElementById('recentlyViewedSection');
    var grid = document.getElementById('recentlyViewedGrid');
    if (!section || !grid) return;
    try {
      var list = JSON.parse(localStorage.getItem('ray_recently_viewed') || '[]');
      if (window.currentProductHandle) {
        list = list.filter(function (p) { return p.handle !== window.currentProductHandle; });
      }
      if (list.length === 0) return;
      list.slice(0, 4).forEach(function (p, i) {
        var card = document.createElement('div');
        card.className = 'product-card reveal-on-scroll';
        card.style.setProperty('--d', i + 1);
        card.innerHTML =
          '<div class="product-card__tilt"><a href="' + p.url + '" class="product-card__image-wrap">' +
          '<img class="product-card__image product-card__image--main" src="' + p.image + '" alt="' + p.title + '">' +
          '<span class="product-card__quickshop">Quick View</span></a></div>' +
          '<h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
          '<p class="product-card__price">' + p.price + '</p>';
        grid.appendChild(card);
      });
      section.style.display = '';
      grid.querySelectorAll('.product-card__tilt').forEach(function (c) { attachTilt(c, 12); });
      var newReveal = grid.querySelectorAll('.reveal-on-scroll');
      if (enableVisualEffects && typeof ScrollTrigger !== 'undefined') {
        gsap.fromTo(newReveal, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1, ease: "power4.out", stagger: .1, scrollTrigger: { trigger: grid, start: "top 88%" } });
      } else {
        newReveal.forEach(function (el) { el.classList.add('is-visible'); });
      }
    } catch (e) {}
  })();

  /* ---------- Wishlist ---------- */
  var WISHLIST_KEY = 'ray_wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; } }
  function saveWishlist(list) { try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {} }
  function isWished(handle) { return getWishlist().some(function (p) { return p.handle === handle; }); }

  function updateWishlistCount() {
    var countEl = document.getElementById('wishlistCount');
    if (!countEl) return;
    var count = getWishlist().length;
    countEl.textContent = count;
    countEl.style.display = count > 0 ? 'flex' : 'none';
  }

  function refreshHeartStates() {
    document.querySelectorAll('.wishlist-heart').forEach(function (btn) {
      btn.classList.toggle('is-active', isWished(btn.getAttribute('data-handle')));
    });
  }

  document.querySelectorAll('.wishlist-heart').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var handle = btn.getAttribute('data-handle');
      var list = getWishlist();
      if (isWished(handle)) {
        list = list.filter(function (p) { return p.handle !== handle; });
      } else {
        list.unshift({
          handle: handle,
          title: btn.getAttribute('data-title'),
          image: btn.getAttribute('data-image'),
          price: btn.getAttribute('data-price'),
          url: btn.getAttribute('data-url')
        });
        if (enableVisualEffects) gsap.fromTo(btn, { scale: 1.4 }, { scale: 1, duration: .5, ease: "elastic.out(1, 0.4)" });
      }
      saveWishlist(list);
      refreshHeartStates();
      updateWishlistCount();
    });
  });
  refreshHeartStates();
  updateWishlistCount();

  /* ---------- Wishlist page rendering ---------- */
  (function () {
    var grid = document.getElementById('wishlistGrid');
    var empty = document.getElementById('wishlistEmpty');
    if (!grid) return;
    var list = getWishlist();
    if (list.length === 0) { if (empty) empty.style.display = ''; return; }
    list.forEach(function (p, i) {
      var card = document.createElement('div');
      card.className = 'product-card reveal-on-scroll';
      card.style.setProperty('--d', i + 1);
      card.innerHTML =
        '<div class="product-card__tilt"><a href="' + p.url + '" class="product-card__image-wrap">' +
        '<img class="product-card__image product-card__image--main" src="' + p.image + '" alt="' + p.title + '">' +
        '</a><button type="button" class="wishlist-heart is-active" data-handle="' + p.handle + '" data-title="' + p.title + '" data-image="' + p.image + '" data-price="' + p.price + '" data-url="' + p.url + '">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 20s-7-4.35-9.5-8.5C.5 8 2 4.5 5.5 4c2-.3 3.8.7 4.5 2 .7-1.3 2.5-2.3 4.5-2 3.5.5 5 4 3 7.5C19 15.65 12 20 12 20z" stroke="currentColor" stroke-width="1.5"/></svg></button></div>' +
        '<h3 class="product-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
        '<p class="product-card__price">' + p.price + '</p>';
      grid.appendChild(card);
      var heart = card.querySelector('.wishlist-heart');
      heart.addEventListener('click', function () {
        saveWishlist(getWishlist().filter(function (item) { return item.handle !== p.handle; }));
        card.remove();
        updateWishlistCount();
        if (getWishlist().length === 0 && empty) empty.style.display = '';
      });
      card.querySelectorAll('.product-card__tilt').forEach(function (c) { attachTilt(c, 12); });
    });
  })();

  /* ---------- First-visit discount popup ---------- */
  (function () {
    var backdrop = document.getElementById('discountPopupBackdrop');
    if (!backdrop || !window.themeSettings || !window.themeSettings.showDiscountPopup) return;
    var SEEN_KEY = 'ray_popup_seen';
    try { if (localStorage.getItem(SEEN_KEY)) return; } catch (e) {}
    var delay = (window.themeSettings.popupDelay || 6) * 1000;
    setTimeout(function () {
      backdrop.classList.add('is-open');
      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    }, delay);
    var closeBtn = document.getElementById('discountPopupClose');
    if (closeBtn) closeBtn.addEventListener('click', function () { backdrop.classList.remove('is-open'); });
    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) backdrop.classList.remove('is-open'); });
  })();

  /* ---------- Search toggle ---------- */
  var searchToggle = document.getElementById('searchToggle');
  var searchBar = document.getElementById('searchBar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () { searchBar.classList.toggle('is-open'); });
  }

  /* ---------- Cart drawer ---------- */
  var cartToggle = document.getElementById('cartToggle');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartBackdrop = document.getElementById('cart-drawer-backdrop');
  var cartClose = document.querySelector('.cart-drawer__close');

  function openCart() {
    if (!cartDrawer || !cartBackdrop) return;
    cartDrawer.classList.add('is-open');
    cartBackdrop.classList.add('is-open');
    renderCartDrawer();
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartBackdrop) cartBackdrop.classList.remove('is-open');
  }
  if (cartToggle && cartDrawer && cartBackdrop) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>\"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '\"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function renderCartDrawer() {
    fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
      var container = document.getElementById('cart-drawer-items');
      if (!container) return;
      if (cart.item_count === 0) { container.innerHTML = '<p>Your bag is empty.</p>'; return; }
      var html = '';

      if (window.themeSettings && window.themeSettings.showFreePerkBar && window.themeSettings.freePerkThreshold > 0) {
        var thresholdCents = window.themeSettings.freePerkThreshold * 100;
        var label = window.themeSettings.freePerkLabel;
        if (cart.total_price >= thresholdCents) {
          html += '<div class="free-perk-bar free-perk-bar--unlocked"><p>🎉 You\'ve unlocked <strong>' + label + '</strong>!</p><div class="free-perk-bar__track"><div class="free-perk-bar__fill" style="width:100%;"></div></div></div>';
        } else {
          var remaining = thresholdCents - cart.total_price;
          var percent = Math.min(100, Math.round((cart.total_price / thresholdCents) * 100));
          html += '<div class="free-perk-bar"><p>Add <strong>' + formatMoney(remaining) + '</strong> more to unlock <strong>' + label + '</strong>!</p><div class="free-perk-bar__track"><div class="free-perk-bar__fill" style="width:' + percent + '%;"></div></div></div>';
        }
      }

      cart.items.forEach(function (item) {
        var variantLabel = item.variant_title && item.variant_title !== 'Default Title'
          ? ' — ' + item.variant_title
          : '';

        html += '<div style="display:flex;gap:14px;margin-bottom:20px;">' +
          '<div style="width:70px;height:70px;border-radius:4px;background:linear-gradient(160deg,#efe7d8,#f9f4ea);display:flex;align-items:center;justify-content:center;padding:6px;box-sizing:border-box;">' +
          '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" style="max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;"></div>' +
          '<div><p style="margin:0;font-size:14px;">' + escapeHtml(item.product_title) + escapeHtml(variantLabel) + '</p>' +
          '<p style="margin:4px 0;font-size:13px;color:#8b8578;">Qty: ' + item.quantity + '</p>' +
          '<p style="margin:0;font-size:14px;">' + formatMoney(item.line_price) + '</p></div></div>';
      });
      html += '<p style="font-size:16px;margin-top:20px;"><strong>Subtotal: ' + formatMoney(cart.total_price) + '</strong></p>';
      html += '<a href="/cart" class="btn btn--magenta btn--full" style="margin-top:16px;">View Bag & Checkout</a>';
      container.innerHTML = html;
    });
  }

  function formatMoney(cents) { return 'Rs. ' + (cents / 100).toFixed(2); }

  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () { openCart(); updateCartCount(); })
        .catch(function () { form.submit(); });
    });
  });

  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    });
  }

  /* ---------- 3D tilt (smoothed with GSAP if available) ---------- */
  function attachTilt(el, strength) {
    strength = strength || 12;
    var setX, setY;
    if (enableVisualEffects) {
      setX = gsap.quickTo(el, "rotationY", { duration: .5, ease: "power3" });
      setY = gsap.quickTo(el, "rotationX", { duration: .5, ease: "power3" });
    }
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      if (enableVisualEffects) { setX(x * strength); setY(-y * strength); }
      else { el.style.transform = 'rotateY(' + (x * strength) + 'deg) rotateX(' + (-y * strength) + 'deg)'; }
    });
    el.addEventListener('mouseleave', function () {
      if (enableVisualEffects) { setX(0); setY(0); } else { el.style.transform = 'rotateY(0) rotateX(0)'; }
    });
  }
  document.querySelectorAll('.product-card__tilt').forEach(function (card) { attachTilt(card, 12); });
  document.querySelectorAll('.split-hero__bottle').forEach(function (bottle) {
    var side = bottle.closest('.split-hero__side');
    attachTiltCustom(side, bottle, 18);
  });
  function attachTiltCustom(container, target, strength) {
    var setX, setY;
    if (enableVisualEffects) {
      setX = gsap.quickTo(target, "rotationY", { duration: .5, ease: "power3" });
      setY = gsap.quickTo(target, "rotationX", { duration: .5, ease: "power3" });
    }
    container.addEventListener('mousemove', function (e) {
      var rect = container.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      if (enableVisualEffects) { setX(x * strength); setY(-y * strength); }
      else { target.style.transform = 'rotateY(' + (x * strength) + 'deg) rotateX(' + (-y * strength) + 'deg)'; }
    });
    container.addEventListener('mouseleave', function () {
      if (enableVisualEffects) { setX(0); setY(0); } else { target.style.transform = 'rotateY(0) rotateX(0)'; }
    });
  }

  var mainImgWrap = document.querySelector('.product-page__main-image');
  var mainImageTilt = document.getElementById('mainProductImage');
  if (mainImgWrap && mainImageTilt) attachTiltCustom(mainImgWrap, mainImageTilt, 8);

  /* ---------- Elastic / magnetic buttons ---------- */
  document.querySelectorAll('.btn, .magnetic').forEach(function (btn) {
    var mx, my;
    if (enableVisualEffects) {
      mx = gsap.quickTo(btn, "x", { duration: .4, ease: "power3" });
      my = gsap.quickTo(btn, "y", { duration: .4, ease: "power3" });
    }
    btn.addEventListener('mousemove', function (e) {
      var rect = btn.getBoundingClientRect();
      var x = e.clientX - rect.left - rect.width / 2;
      var y = e.clientY - rect.top - rect.height / 2;
      if (enableVisualEffects) { mx(x * 0.2); my(y * 0.3); }
      else { btn.style.transform = 'translate(' + (x * 0.2) + 'px,' + (y * 0.3) + 'px)'; }
    });
    btn.addEventListener('mouseleave', function () {
      if (enableVisualEffects) { gsap.to(btn, { x: 0, y: 0, duration: .5, ease: "elastic.out(1, 0.4)" }); }
      else { btn.style.transform = 'translate(0,0)'; }
    });
  });

  /* ---------- Floating bottle + parallax glow (GSAP infinite) ---------- */
  if (enableVisualEffects) {
    gsap.utils.toArray('.split-hero__bottle img').forEach(function (img, i) {
      gsap.to(img, { y: -16, duration: 2.6 + i * 0.3, ease: "sine.inOut", repeat: -1, yoyo: true });
    });
    gsap.utils.toArray('.split-hero__glow, .newsletter__mist, .notes-section__glow').forEach(function (glowEl, i) {
      gsap.to(glowEl, { x: 30, y: -20, duration: 8 + i, ease: "sine.inOut", repeat: -1, yoyo: true });
    });
  }

  /* ---------- Testimonial slider ---------- */
  var slides = document.querySelectorAll('.testimonial-slide');
  var dots = document.querySelectorAll('.testimonial-dots button');
  var current = 0;
  function showSlide(i) {
    slides.forEach(function (s, idx) {
      var active = idx === i;
      if (enableVisualEffects && active) { gsap.fromTo(s, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: .6, ease: "power2.out" }); }
      s.classList.toggle('is-active', active);
    });
    dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    current = i;
  }
  if (slides.length) {
    showSlide(0);
    dots.forEach(function (dot, idx) { dot.addEventListener('click', function () { showSlide(idx); }); });
    setInterval(function () { showSlide((current + 1) % slides.length); }, 5000);
  }

  /* ---------- Product gallery thumbnails ---------- */
  var mainImage = document.getElementById('mainProductImage');
  document.querySelectorAll('.product-page__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) {
        if (enableVisualEffects) {
          gsap.to(mainImage, { opacity: 0, scale: .96, duration: .2, onComplete: function () {
            mainImage.src = thumb.getAttribute('data-full');
            gsap.to(mainImage, { opacity: 1, scale: 1, duration: .3, ease: "power2.out" });
          }});
        } else { mainImage.src = thumb.getAttribute('data-full'); }
      }
      document.querySelectorAll('.product-page__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Option pills + variant/cart synchronization ---------- */
  (function () {
    var variantsElement = document.getElementById('ProductVariantsJson');
    var variantIdInput = document.getElementById('ProductSelectId');

    if (!variantsElement || !variantIdInput) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsElement.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    if (!variants.length) return;

    var optionButtons = Array.from(document.querySelectorAll('.option-pill'));
    var priceElement = document.querySelector('.product-page__price .now');
    var addButton = document.getElementById('mainAddToCart');
    var stickyPrice = document.querySelector('.sticky-atc__info span:nth-child(2)');
    var stickyButton = document.getElementById('stickyAddToCart');

    var initialVariant = variants.find(function (variant) {
      return String(variant.id) === String(variantIdInput.value);
    }) || variants[0];

    var selectedOptions = (initialVariant.options || []).slice();

    function getSelectedVariant() {
      return variants.find(function (variant) {
        return (variant.options || []).every(function (option, index) {
          return option === selectedOptions[index];
        });
      });
    }

    function updateVariant() {
      var selectedVariant = getSelectedVariant();
      if (!selectedVariant) return;

      variantIdInput.value = selectedVariant.id;

      if (priceElement) priceElement.textContent = selectedVariant.price;
      if (stickyPrice) stickyPrice.textContent = selectedVariant.price;

      if (addButton) {
        addButton.disabled = !selectedVariant.available;
        addButton.textContent = selectedVariant.available
          ? 'Add to Bag — ' + selectedVariant.price
          : 'Sold Out';
      }

      if (stickyButton) stickyButton.disabled = !selectedVariant.available;

      optionButtons.forEach(function (button) {
        var optionIndex = Number(button.dataset.optionIndex);
        var isSelected = selectedOptions[optionIndex] === button.dataset.value;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var optionIndex = Number(button.dataset.optionIndex);
        selectedOptions[optionIndex] = button.dataset.value;
        updateVariant();

        if (enableVisualEffects) {
          gsap.fromTo(button, { scale: .9 }, {
            scale: 1,
            duration: .4,
            ease: 'back.out(2)'
          });
        }
      });
    });

    var productForm = variantIdInput.closest('form');
    if (productForm) {
      productForm.addEventListener('submit', function () {
        var selectedVariant = getSelectedVariant();
        if (selectedVariant) variantIdInput.value = selectedVariant.id;
      });
    }

    updateVariant();
  })();

  /* ---------- Quantity selectors ---------- */
  document.querySelectorAll('.qty-selector').forEach(function (selector) {
    var input = selector.querySelector('.qty-input');
    var minus = selector.querySelector('.qty-minus');
    var plus = selector.querySelector('.qty-plus');
    if (minus) minus.addEventListener('click', function () {
      var val = parseInt(input.value || '1', 10);
      if (val > (parseInt(input.min, 10) || 0)) input.value = val - 1;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      var val = parseInt(input.value || '1', 10);
      input.value = val + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- Cart page line quantity updates ---------- */
  document.querySelectorAll('.cart-table .qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var line = input.getAttribute('data-line');
      if (!line) return;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: parseInt(input.value, 10) })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Header shadow on scroll ---------- */
  var header = document.getElementById('siteHeader');
  window.addEventListener('scroll', function () {
    if (header) header.style.boxShadow = window.pageYOffset > 20 ? '0 4px 20px rgba(0,0,0,.06)' : 'none';
  }, { passive: true });
});